export default "__VITE_ASSET__DFYRojIk__"